/**
 * @typedef {Object} PaymentCtx
 * @property {string} projectId
 * @property {string} organizationId
 * @property {object} cart
 * @property {string} currency
 * @property {string} returnUrl
 * @property {string} cancelUrl
 */

/**
 * @typedef {Object} PaymentResult
 * @property {'success'|'redirecting'|'requires_action'|'failed'} status
 * @property {string=} orderId
 * @property {object=} details
 */

/**
 * @typedef {Object} PaymentClient
 * @property {'stripe'|'multisafepay'} name
 * @property {boolean} usesInternalSubmitButton
 * @property {(host: HTMLElement, ctx: PaymentCtx) => Promise<void>} mount
 * @property {(ctx: PaymentCtx) => Promise<PaymentResult>} submit
 * @property {() => Promise<void>} destroy
 */

export class UnknownProviderError extends Error {
  constructor(provider) {
    super(`Unknown payment provider: ${provider}`);
    this.name = 'UnknownProviderError';
    this.code = 'PROVIDER_UNKNOWN';
  }
}
